import { SafeAreaInsets, SafeAreaInsetType } from "@components/ScalableWrapper";
import { AuthPlatform } from "@src/contexts/AuthProvider";

export function getWindowInnerHeight(safeAreaInsets?: SafeAreaInsets) {
  const safeAreaTopInset = getSafeAreaInset("t", safeAreaInsets?.top);
  const safeAreaBottomInset = getSafeAreaInset("b", safeAreaInsets?.bottom);

  return window.innerHeight - (safeAreaTopInset + safeAreaBottomInset);
}

export function getWindowInnerWidth(safeAreaInsets?: SafeAreaInsets) {
  const safeAreaLeftInset = getSafeAreaInset("l", safeAreaInsets?.left);
  const safeAreaRightInset = getSafeAreaInset("r", safeAreaInsets?.right);

  return window.innerWidth - (safeAreaLeftInset + safeAreaRightInset);
}

/**
 * Get the value of the URL hash parameter "r"
 * example: #r=RAAAA => "AAAA"
 */
export function getUrlHashParameter() {
  const hash = window.location.hash;
  const params = new URLSearchParams(hash.slice(1));
  const rValue = params.get("r");
  return rValue?.slice(1) ?? "";
}

export function getSafeAreaInset(
  dir: "t" | "b" | "l" | "r",
  safeAreaInsetType?: SafeAreaInsetType
) {
  if (safeAreaInsetType === "native") {
    return +getComputedStyle(document.documentElement)
      .getPropertyValue(`--sa${dir}`)
      .slice(0, -2);
  } else {
    return +getComputedStyle(document.documentElement)
      .getPropertyValue(`--dsa${dir}`)
      .slice(0, -2);
  }
}

export const getUser = async (jwt: string, platform: AuthPlatform | null) => {
  const url = `${
    import.meta.env.VITE_PLAYROOM_BASE_URL
  }/auth/${platform?.toLowerCase()}/get-user?gameId=${
    import.meta.env.VITE_GAME_ID
  }`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${jwt}`,
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch user");
  }
  const resp = await response.json();
  let user = resp;
  if (platform === AuthPlatform.GOOGLE) {
    user = {
      user: {
        id: resp?.user?.email,
        username: resp?.user?.displayName,
        avatar: resp?.user?.photoUrl,
      },
      avatarSrc: resp?.user?.photoUrl,
    };
  }

  return user;
};
